import { makeAddition, makeUnauthorized, makeUniqueViolation, makeUnknown, makeValidation, } from "../../AthenaEventSaveError/AthenaEventSaveError.js";
import { extractThrownValueDetails } from "../../utils/extractThrownValueDetails.js";
export function toAthenaEventSaveResults(response, request) {
    return request.body.map((athenaEvent, index) => {
        return response.body.successes?.includes(athenaEvent.id)
            ? {
                athenaEvent: athenaEvent,
                succeeded: true,
                error: null,
            }
            : {
                athenaEvent: athenaEvent,
                succeeded: false,
                error: getErrorFromFailure(response.body.failures?.[index]),
            };
    });
}
function getErrorFromFailure(failure) {
    if (!failure) {
        return makeUnknown(extractThrownValueDetails("Save result did not report AthenaEvent save as neither successful nor failed."));
    }
    // `failure.message` is typed `any` by the backend schema: it's usually a
    // string, but for e.g. ValidationError it can be a structured payload (a
    // Pydantic error list/dict). Normalizing through `extractThrownValueDetails`
    // means non-string payloads get their full content captured (see `content`
    // on the "object" case) instead of being silently dropped.
    const details = extractThrownValueDetails(failure.message);
    switch (failure.type) {
        case "UniqueViolation":
            return makeUniqueViolation(details);
        case "AuthorizationError":
            return makeUnauthorized(details);
        case "AdditionError":
            return makeAddition(details);
        case "ValidationError":
            return makeValidation(details);
    }
}
//# sourceMappingURL=PostEvents.js.map